import components from "./components";
import legal from "./legal";
import pages from "./pages";

const resources = {
  ...components,
  ...pages,
  legal: {
    ...components.legal,
    ...legal,
  },
};

export default resources;
